import React, { useContext } from 'react';
import InfoArteFinalContainer from '../ArteFinalInfo/InfoArteFinalContainer';
import InfoArteFinalTitle from '../ArteFinalInfo/InfoArteFinalTitle';
import InfoArteFinalPrice from '../ArteFinalInfo/InfoArteFinalPrice';
import { numberToPrice } from '../../../../utils/numberFunctions';
import { useLocation, useNavigate } from 'react-router-dom';
import { UserContext } from '../../../../context/UserProvider';
import cls from 'classnames';
import DeleteFormat from './DeleteFormat';
import { IconButton } from '@mui/material';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import MaterialTooltip from '../../../../ui/tooltip/MaterialTooltip';

const FormatItem = ({ formato, isCustom, numProviderFormat }) => {
  const { userRole } = useContext(UserContext);

  const navigate = useNavigate();
  const location = useLocation();

  const handleRedirectToPageFormat = () => {
    if (userRole !== 'MasterAdmin') return;
    if (location.pathname[location.pathname.length - 1] === '/') {
      navigate(`${location.pathname}format-provider/${formato._id}`);
    } else {
      navigate(`${location.pathname}/format-provider/${formato._id}`);
    }
  };

  return (
    <InfoArteFinalContainer
      classnames={cls(
        'item-arte-final-container',
        'item-arte-final-container--format',
        !formato.active ? 'item-arte-final-container--not-active' : '',
        userRole === 'MasterAdmin' && 'item-arte-final-container--pointer',
      )}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div
          onClick={handleRedirectToPageFormat}
          style={{ display: 'flex', flexDirection: 'column', gap: '.5rem', width: '100%', padding: '1rem 0 1rem 1rem' }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            <InfoArteFinalTitle classnames="display-sb-c">{formato.code?.trim() || 'Sin código'}</InfoArteFinalTitle>
            <InfoArteFinalTitle style={{ color: '#757575' }}>
              {formato?.provider?.name ?? 'Sin definir'}
            </InfoArteFinalTitle>
          </div>
          <div
            style={{ display: 'flex', justifyContent: isCustom ? 'flex-end' : 'space-between', alignItems: 'center' }}
          >
            {!isCustom && <InfoArteFinalPrice>{numberToPrice(formato.price || 0)} €</InfoArteFinalPrice>}
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              {formato.hasIssues && (
                <MaterialTooltip
                  variation="warning"
                  title={
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                      {formato.issues?.map((issue, index) => (
                        <div key={index}>{issue}</div>
                      ))}
                    </div>
                  }
                >
                  <IconButton className="alert-message">
                    <ReportProblemIcon color="warning" />
                  </IconButton>
                </MaterialTooltip>
              )}
              <DeleteFormat numProviderFormat={numProviderFormat} formato={formato} />
            </div>
          </div>
        </div>
      </div>
    </InfoArteFinalContainer>
  );
};

export default FormatItem;
